import { useState, useCallback } from "react";
import {
  generateCaptcha,
  generateCaptchaImage,
} from "../Utility/GenerateCaptcha";

const useCaptcha = () => {
  const [captcha, setCaptcha] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");

  const updateCaptcha = useCallback(() => {
    const newCaptcha = generateCaptcha();
    const newCaptchaImage = generateCaptchaImage(newCaptcha);
    setCaptcha(newCaptcha);
    setCaptchaImage(newCaptchaImage);
  }, []);

  // Initialize CAPTCHA on first render
  useState(() => {
    updateCaptcha();
  }, []);

  return { captcha, captchaImage, refreshCaptcha: updateCaptcha };
};

export default useCaptcha;
